import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="footer" className="bg-burgundyDeep text-cream/65 border-t border-cream/10">
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-16 md:py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 mb-14">
                    <div className="md:col-span-5">
                        <div className="flex items-baseline gap-3 mb-5">
                            <span className="font-serif text-4xl text-cream">Štrokay</span>
                            <span className="font-serif-italic text-cream/60">vinařství</span>
                        </div>
                        <p className="text-sm leading-relaxed max-w-md text-cream/70">
                            Rodinné vinařství s 200letou tradicí na jižní Moravě. Víno, degustace
                            a ubytování pod jednou střechou.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <p className="overline mb-5 text-cream/50">Kontakt</p>
                        <ul className="space-y-3 text-sm">
                            <li className="flex items-start gap-3">
                                <Mail size={14} className="mt-1 shrink-0" />
                                <a href="mailto:martinstrokay@gmail.com" className="hover:text-cream transition-colors">martinstrokay@gmail.com</a>
                            </li>
                            <li className="flex items-start gap-3">
                                <Phone size={14} className="mt-1 shrink-0" />
                                <a href="tel:+420733266209" className="hover:text-cream transition-colors">+420 733 266 209</a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin size={14} className="mt-1 shrink-0" />
                                <span>Nechory, 696 21<br />Josefov-Prušánky</span>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="overline mb-5 text-cream/50">Sekce</p>
                        <ul className="grid grid-cols-2 gap-y-3 text-sm">
                            <li><a href="#o-vinarstvi" className="hover:text-cream transition-colors">O vinařství</a></li>
                            <li><a href="#vina" className="hover:text-cream transition-colors">Vína</a></li>
                            <li><a href="#degustace" className="hover:text-cream transition-colors">Degustace</a></li>
                            <li><a href="#galerie" className="hover:text-cream transition-colors">Galerie</a></li>
                            <li><a href="#ubytovani" className="hover:text-cream transition-colors">Ubytování</a></li>
                            <li><a href="#kontakt" className="hover:text-cream transition-colors">Kontakt</a></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-cream/10 pt-8 flex flex-col md:flex-row gap-4 md:gap-0 items-start md:items-center justify-between text-[10px] uppercase tracking-[0.25em] text-cream/45">
                    <div>© {new Date().getFullYear()} Vinařství Štrokay · Všechna práva vyhrazena</div>
                    <div className="flex gap-6">
                        <a href="#uvod" className="hover:text-cream">Nahoru</a>
                        <Link to="/admin" data-testid="admin-link" className="hover:text-cream">Admin</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
